/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { shopOrderAdminControllerFindByIdV1 } from '../fn/shop-order-admin/shop-order-admin-controller-find-by-id-v-1';
import { ShopOrderAdminControllerFindByIdV1$Params } from '../fn/shop-order-admin/shop-order-admin-controller-find-by-id-v-1';
import { shopOrderAdminControllerGetStatsV1 } from '../fn/shop-order-admin/shop-order-admin-controller-get-stats-v-1';
import { ShopOrderAdminControllerGetStatsV1$Params } from '../fn/shop-order-admin/shop-order-admin-controller-get-stats-v-1';
import { shopOrderAdminControllerSearchV1 } from '../fn/shop-order-admin/shop-order-admin-controller-search-v-1';
import { ShopOrderAdminControllerSearchV1$Params } from '../fn/shop-order-admin/shop-order-admin-controller-search-v-1';
import { shopOrderAdminControllerUpdateMemoV1 } from '../fn/shop-order-admin/shop-order-admin-controller-update-memo-v-1';
import { ShopOrderAdminControllerUpdateMemoV1$Params } from '../fn/shop-order-admin/shop-order-admin-controller-update-memo-v-1';
import { ShopOrderDetailDto } from '../models/shop-order-detail-dto';
import { ShopOrderDto } from '../models/shop-order-dto';
import { ShopOrderStatsDto } from '../models/shop-order-stats-dto';

@Injectable({ providedIn: 'root' })
export class ShopOrderAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopOrderAdminControllerSearchV1()` */
  static readonly ShopOrderAdminControllerSearchV1Path = '/api/v1/shop-orders/admin';

  /**
   * 주문 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderAdminControllerSearchV1$Response(params: ShopOrderAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = shopOrderAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderAdminControllerSearchV1(params: ShopOrderAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.shopOrderAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ShopOrderDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `shopOrderAdminControllerGetStatsV1()` */
  static readonly ShopOrderAdminControllerGetStatsV1Path = '/api/v1/shop-orders/admin/stats';

  /**
   * 주문 통계 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderAdminControllerGetStatsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderAdminControllerGetStatsV1$Response(params?: ShopOrderAdminControllerGetStatsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderStatsDto>> {
    const obs = shopOrderAdminControllerGetStatsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 통계 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderAdminControllerGetStatsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderAdminControllerGetStatsV1(params?: ShopOrderAdminControllerGetStatsV1$Params, context?: HttpContext): Observable<ShopOrderStatsDto> {
    const resp = this.shopOrderAdminControllerGetStatsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderStatsDto>): ShopOrderStatsDto => r.body)
    );
  }

  /** Path part for operation `shopOrderAdminControllerFindByIdV1()` */
  static readonly ShopOrderAdminControllerFindByIdV1Path = '/api/v1/shop-orders/admin/{id}';

  /**
   * 주문 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderAdminControllerFindByIdV1$Response(params: ShopOrderAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
    const obs = shopOrderAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopOrderAdminControllerFindByIdV1(params: ShopOrderAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ShopOrderDetailDto> {
    const resp = this.shopOrderAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDetailDto>): ShopOrderDetailDto => r.body)
    );
  }

  /** Path part for operation `shopOrderAdminControllerUpdateMemoV1()` */
  static readonly ShopOrderAdminControllerUpdateMemoV1Path = '/api/v1/shop-orders/admin/{id}/memo';

  /**
   * 주문 메모 수정 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopOrderAdminControllerUpdateMemoV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderAdminControllerUpdateMemoV1$Response(params: ShopOrderAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
    const obs = shopOrderAdminControllerUpdateMemoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 메모 수정 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopOrderAdminControllerUpdateMemoV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopOrderAdminControllerUpdateMemoV1(params: ShopOrderAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<ShopOrderDetailDto> {
    const resp = this.shopOrderAdminControllerUpdateMemoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrderDetailDto>): ShopOrderDetailDto => r.body)
    );
  }

}
